
if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
  setTimeout(function() {
    window.location = 'microsoft-edge:' + window.location;
  }, 1);
}